import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export function formatApiError(
  detail,
  fallback = "Something went wrong. Please try again."
) {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;

  if (Array.isArray(detail)) {
    return detail
      .map((e) =>
        e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)
      )
      .filter(Boolean)
      .join(" ");
  }

  if (detail && typeof detail.msg === "string") return detail.msg;

  return String(detail);
}
